module.exports = __webpack_public_path__ + "img/email-header-relationshipmanager@2x.2b60c502.png";